const Automation = () => {
    return <div>Automation</div>;
};

export default Automation;